import PGALogo from "@/assets/images/pga-logo.svg";
import PGALogoDecember from "@/assets/images/pga-logo-december.png";
import PGALogoAprilFools from "@/assets/images/pga-logo-april-fools.gif";
import { Link } from "@/router";

const NavLogo = ({ className }: { className?: string }) => {
  const today = new Date();
  const isDecember = today.getMonth() === 11;
  const isAprilFoolsDay = today.getMonth() === 3 && today.getDate() === 1;
  const logoClassName = className ?? "h-[60px] w-[60px]";

  return (
    <Link to="/" className="shrink-0">
      {isAprilFoolsDay ? (
        <img src={PGALogoAprilFools} alt="PGA" className={logoClassName} style={{ width: "auto", height: "auto" }} />
      ) : isDecember ? (
        <img src={PGALogoDecember} alt="PGA" className={logoClassName} />
      ) : (
        <img src={PGALogo} alt="PGA" className={logoClassName} />
      )}
    </Link>
  );
};

export default NavLogo;
